"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactTooltip = exports.useScrollDetector = exports.useWindowWidth = void 0;
const dom_1 = require("@floating-ui/dom");
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
function useWindowWidth() {
    const [width, setWidth] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(function () {
        function update() {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", update);
        update();
        return (() => window.removeEventListener("resize", update));
    }, []);
    return width;
}
exports.useWindowWidth = useWindowWidth;
function useScrollDetector() {
    const [c, setC] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(function () {
        function update() {
            setC(c => c + 1);
        }
        document.addEventListener("scroll", update, true);
        return (() => document.removeEventListener("scroll", update));
    }, []);
    return c;
}
exports.useScrollDetector = useScrollDetector;
function ReactTooltip({ tooltip, children, inline = true, className = "", container = null, delay = 1000, arrowMaxOffset = Infinity, arrowMinOffset = 10, disabled = false, forward = false, interation = "mouseenter", placement = 'top' }) {
    var _a;
    const ref = (0, react_1.useRef)(null);
    const popRef = (0, react_1.useRef)(null);
    const arrowRef = (0, react_1.useRef)(null);
    const handle = (0, react_1.useRef)(0);
    const [show, setShowS] = (0, react_1.useState)(false);
    const width = useWindowWidth();
    const [place, setPlace] = (0, react_1.useState)(placement);
    const scrollId = useScrollDetector();
    const tooltipId = (0, react_1.useId)();
    function setShow(a) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (a === true)
                return setShowS(a);
            (_a = popRef === null || popRef === void 0 ? void 0 : popRef.current) === null || _a === void 0 ? void 0 : _a.classList.add("fadeout");
            setTimeout(() => setShowS(a), 300);
        });
    }
    function onEnter() {
        if (handle.current)
            clearTimeout(handle.current);
        handle.current = setTimeout(() => setShow(true), delay);
    }
    function onLeave() {
        if (handle.current)
            clearTimeout(handle.current);
        setShow(false);
    }
    function click() {
        setShow(s => !s);
    }
    (0, react_1.useEffect)(function () {
        if (!show)
            return;
        if (disabled)
            return;
        if (popRef == null)
            return;
        if (ref == null)
            return;
        const aP = !placement.match(/end/) ? {} : { padding: { right: 10 } };
        (0, dom_1.computePosition)(ref.current, popRef.current, {
            placement, strategy: container ? 'fixed' : 'absolute',
            middleware: [
                (0, dom_1.offset)(8), (0, dom_1.flip)(),
                (0, dom_1.shift)({ padding: 10, limiter: (0, dom_1.limitShift)({ offset: 10, }), }),
                (0, dom_1.arrow)(Object.assign({ element: arrowRef.current }, aP))
            ]
        }).then(({ x, y, placement, middlewareData: { arrow } }) => {
            if (popRef.current == null)
                return;
            Object.assign(popRef.current.style, {
                left: `${x}px`,
                top: `${y}px`,
                visibility: 'visible'
            });
            Object.assign(arrowRef.current.style, {
                left: `${Math.min(Math.max(arrow.x, arrowMinOffset), arrowMaxOffset)}px`,
                top: `${arrow.y}px`,
            });
            setPlace(placement);
        });
        function handle(ev) {
            if (ev.type == 'focus')
                return setShow(false);
            if (ref.current == ev.target || ref.current.contains(ev.target))
                return setShow(false);
            if (popRef.current == ev.target || popRef.current.contains(ev.target))
                return;
            setShow(false);
        }
        function anotherPopup(ev) {
            if (ev.detail.id != tooltipId)
                setShow(false);
        }
        document.addEventListener("click", handle);
        document.addEventListener("focus", handle, true);
        document.addEventListener("tooltip", anotherPopup);
        return () => {
            document.removeEventListener("click", handle);
            document.removeEventListener("focus", handle);
            document.removeEventListener("tooltip", anotherPopup);
        };
    }, [show, width, scrollId]);
    (0, react_1.useEffect)(() => {
        if (show)
            document.dispatchEvent(new CustomEvent("tooltip", { detail: { id: tooltipId } }));
    }, [show]);
    const interactions = (0, react_1.useMemo)(() => {
        if (interation == 'click')
            return { onClick: click };
        return {
            onMouseEnter: onEnter,
            onTouchStart: onEnter,
            onMouseLeave: onLeave,
        };
    }, [interation]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        !forward ?
            react_1.default.createElement("div", Object.assign({ ref: ref, className: (inline ? 'd-inline-block' : '') + ' ' + className }, interactions), children) :
            children(ref, interactions),
        show && !disabled && (0, react_dom_1.createPortal)(react_1.default.createElement("div", { ref: popRef, className: `popover popover-tooltip tooltip-${place}` },
            tooltip,
            react_1.default.createElement("div", { className: "arrow-tooltip", ref: arrowRef })), container ? ((_a = (document.querySelector(container))) !== null && _a !== void 0 ? _a : document.body) : document.body));
}
exports.ReactTooltip = ReactTooltip;
//# sourceMappingURL=ReactTooltip.js.map